module.exports = __webpack_public_path__ + "static/img/boyue.6e9d1d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/boyue.png
// module id = UKyT
// module chunks = 1